import React, { useState, useEffect, useRef } from "react";
import Papa from "papaparse";
import "../ProductList.css";
import AdultSlider from "./AdultSlider";
import { useNavigate } from "react-router-dom";
import { GoMoveToTop } from "react-icons/go";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { images } from './axAdult';
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { productDb } from '../firebaseProducts';
const DrinkwearMenu = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [percentage, setPercentage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [color, setColor] = useState("");
  const [sliderValue, setSliderValue] = useState(4.8);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedTags, setSelectedTags] = useState({
    "Bottles": false,
    Sets: false,
    "Coasters": false,
    "Openers": false,
    "Flasks": false,
    "Key Chain": false,
    "Wine": false,
    "Whiskey": false,
    "Beer": false,
    Shot: false,
    "Sleeves": false,
    Koozies: false,
    Mugs: false,
    Tumblers: false,
    Stoppers: false,
  });

  const itemsPerPage = 12;
  const navigate = useNavigate();
  const videoRef = useRef(null);
const [aspectRatio, setAspectRatio] = useState(75); // default 4:3

useEffect(() => {
  if (images.length > 0) {
    const img = new Image();
    img.src = images[0].src;
    img.onload = () => {
      setAspectRatio((img.height / img.width) * 100);
    };
  }
}, [images]);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);

  
  // const loadCSV = async () => {
  //   const csvUrl = './adultListApparel2.csv';
  //   try {
  //     const response = await fetch(csvUrl);
  //     if (!response.ok) throw new Error('Failed to load CSV file');
  //     const csvData = await response.text();

  //     Papa.parse(csvData, {
  //       complete: (result) => {
  //         const today = new Date();
  //         const data = result.data;
  //         const parsedProducts = data.slice(1).map((item, index) => {
  //           const parseDate = (dateStr) => {
  //             if (!dateStr) return null;
  //             const [month, day, year] = dateStr.split('/').map(Number);
  //             return new Date(year, month - 1, day); // month is 0-indexed
  //           };

  //           const endSaleDate = parseDate(item[43]);

  //           // 🟡 Console logs for debugging
  //           // console.log(`Row ${index + 2}:`);
  //           // console.log('End Sale Date:', endSaleDate);
  //           // console.log('Today:', today);

  //           const isOnSale = endSaleDate && endSaleDate >= today;
  //                   const price = parseFloat(item[1]) || 0;
  //               const salePrice = parseFloat(item[44]) || 0;

  //                           if(salePrice!==0){
  //               const disPercentage= parseFloat(((price-salePrice)/price)*100).toFixed(0)
  //               console.log(disPercentage)
  //               setPercentage(disPercentage)
  //               }
  //           return {
  //             Handle: item[29],
  //             ColorVal: item[33],
  //             Size: item[14],
  //             DefaultImageSrc: item[2],
  //             HoverImageSrc: item[23],
  //             Price: parseFloat(item[1]),
  //             Description: item[3],
  //             Style: item[13],
  //             EndSale: endSaleDate,
  //             Tags: item[6]?.split(',').map(tag => tag.trim()) || [],
  //             isOnSale,
  //           };
  //         });

  //         setProducts(parsedProducts);
  //         setFilteredProducts(parsedProducts);
  //         setLoading(false);
  //       },
  //       header: false,
  //       skipEmptyLines: true,
  //     });
  //   } catch (err) {
  //     setError(err.message);
  //     setLoading(false);
  //   }
  // };
  // const loadCSV = async () => {
  //   // const csvUrl = "/adult-list-menu.csv";
  //    const csvUrl = "/Drinkwear-Menu.csv";
  //   try {
  //     const response = await fetch(csvUrl);
  //     if (!response.ok) throw new Error("Failed to load CSV file");
  //     const csvData = await response.text();
  //     // console.log(csvData);
  //     Papa.parse(csvData, {
  //       complete: (result) => {
  //         const today = new Date();
  //         const data = result.data;

  //         const parsedProducts = data.slice(1).map((item) => {
  //           const parseDate = (dateStr) => {
  //             if (!dateStr) return null;
  //             const [month, day, year] = dateStr.split("/").map(Number);
  //             return new Date(year, month - 1, day);
  //           };

  //           const price = parseFloat(item[1]) || 0;
  //           const salePrice = parseFloat(item[43]) || 0;
  //           const endSaleDate = parseDate(item[42]);
  //           const isOnSale = endSaleDate && endSaleDate >= today;

  //           let discountPercentage = 0;
  //           if (price > 0 && salePrice > 0 && salePrice < price) {
  //             discountPercentage = Math.round(
  //               ((price - salePrice) / price) * 100
  //             );
  //           }

  //           return {
  //             Handle: item[28],
  //             ColorVal: item[33],
  //             Size: item[14],
  //             DefaultImageSrc: item[2],
  //             HoverImageSrc: item[23],
  //             Price: price,
  //             SalePrice: salePrice,
  //             DiscountPercentage: discountPercentage,
  //             Description: item[3],
  //             Style: item[13],
  //             EndSale: endSaleDate,
  //             Tags: item[6]?.split(",").map((tag) => tag.trim()) || [],
  //             isOnSale,
  //           };
  //         });

  //         setProducts(parsedProducts);
  //         setFilteredProducts(parsedProducts);
  //         setLoading(false);
  //       },
  //       header: false,
  //       skipEmptyLines: true,
  //     });
  //   } catch (err) {
  //     setError(err.message);
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   loadCSV();
  // }, []);
const loadFirestoreData = async () => {
  try {
    // console.log("🚀 Fetching products from Firestore…");

    const querySnapshot = await getDocs(collection(productDb, "drinkwear-menu"));
    // console.log("📦 QuerySnapshot size:", querySnapshot.size);

    const today = new Date();

    const parsedProducts = querySnapshot.docs.map((doc, index) => {
      const data = doc.data();

      // Parse SALE_END_DATE like CSV logic
      const parseDate = (dateStr) => {
  if (!dateStr) return null;

  if (dateStr instanceof Date) {
    return dateStr;
  }

  // Firestore Timestamp
  if (dateStr.toDate) {
    return dateStr.toDate();
  }

  if (typeof dateStr === "string") {
    // Case 1: ISO format "YYYY-MM-DD"
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [year, month, day] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day);
    }

    // Case 2: US format "MM/DD/YYYY"
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) {
      const [month, day, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    }
  }

  return new Date(dateStr); // fallback
};

      const endSaleDate = parseDate(data.endSale);

      // const endSaleDate = parseDate(data.SALE_END_DATE);

      const isOnSale = endSaleDate && endSaleDate >= today;
      const price = Math.round((parseFloat(data.Price) + 5) * 100) / 100;
const salePrice = Math.round((parseFloat(data.salePrice) + 5) * 100) / 100;

      let discountPercentage = 0;
      if (price > 0 && salePrice > 0 && salePrice < price) {
        discountPercentage = Math.round(((price - salePrice) / price) * 100);
      }
const getFirstValid = (...values) => {
  return values.find(v => v && v.toString().trim() !== "");
};
      return {
        Handle: data.Title2,
        ColorVal: data.Color,
        Size: data.AVAILABLE_SIZES,
        DefaultImageSrc: data.img || data.model,
        HoverImageSrc: getFirstValid(data.front, data.SIDE_MODEL),
        Price: price,
        Description: data.Body,
        Style: data.Style,
        SalePrice: salePrice,
        DiscountPercentage: discountPercentage,
        EndSale: endSaleDate,
        Tags: data.Tags ? data.Tags.split(",").map((t) => t.trim()) : [],
        isOnSale,
        Id: doc.id,
        min:data.MinQnt
      };
    });

    setProducts(parsedProducts);
    setFilteredProducts(parsedProducts);
    setLoading(false);
  } catch (err) {
    console.error("❌ Error fetching Firestore data:", err);
    setError(err.message);
    setLoading(false);
  }
};

useEffect(() => {
  loadFirestoreData();
}, []);
  const handleAddToCart = (product) => {
    navigate(`/product-drinkwear/${product.Style}`);
  };
  // console.log(products)
  useEffect(() => {
    let updatedProducts = [...products];

    if (color) {
      updatedProducts = updatedProducts.filter((product) =>
        product.ColorVal.split(",").some((c) =>
          c.trim().toLowerCase().includes(color.toLowerCase())
        )
      );
    }

    const selectedTagKeys = Object.keys(selectedTags).filter(
      (tag) => selectedTags[tag]
    );
    if (selectedTagKeys.length > 0) {
      updatedProducts = updatedProducts.filter((product) =>
        selectedTagKeys.some((tag) => product.Tags.includes(tag))
      );
    }

if (searchTerm) {
  updatedProducts = updatedProducts.filter(product => {
    const handle = product?.Handle?.toLowerCase() || "";
    const desc = product?.Description?.toLowerCase() || "";
    return (
      handle.includes(searchTerm.toLowerCase()) ||
      desc.includes(searchTerm.toLowerCase())
    );
  });
}

    const maxPrice = Math.max(...products.map((p) => p.Price));
    const minPrice = Math.min(...products.map((p) => p.Price));
    const targetPrice = minPrice + ((maxPrice - minPrice) * sliderValue) / 100;
    updatedProducts.sort((a, b) => {
      const diffA = Math.abs(a.Price - targetPrice);
      const diffB = Math.abs(b.Price - targetPrice);
      return diffA - diffB || a.Price - b.Price;
    });

    setFilteredProducts(updatedProducts);
  }, [products, selectedTags, searchTerm, sliderValue, color]);

  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = filteredProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleTagChange = (e) => {
    setSelectedTags((prevTags) => ({
      ...prevTags,
      [e.target.name]: e.target.checked,
    }));
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  if (loading) return <span className="loader"></span>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <>
      <div className="product-list-container" id="product-container">
        <div className="sidebar">
          <div className="sidebar-content">
<div 
  className="slider-container"  
  style={{ 
   
    maxWidth: 250, 
    width: "100%", 
    position: "relative", 
    paddingTop: `${aspectRatio}%`
  }}
>

  <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
    <AdultSlider width="100%" height="100%" />
  </div>
</div>


            <div className="search-box">
              <h6 style={{ marginTop: -15, marginLeft: 5 }}>Categories</h6>
              <input
                type="text"
                style={{ fontSize: 8 }}
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search by name..."
              />
            </div>

            <div className="checkbox-filters">
              {Object.keys(selectedTags).map((tag) => (
                <label key={tag}>
                  <input
                    type="checkbox"
                    name={tag}
                    checked={selectedTags[tag]}
                    onChange={handleTagChange}
                  />
                  {tag}
                </label>
              ))}
            </div>
          </div>

          <hr style={{ marginTop: -20, marginBottom: 0 }} />
          <div className="slider-container" style={{ textAlign: "center" }}>
            <label htmlFor="price-slider">Sort by Price</label>
            <input
              type="range"
              id="price-slider"
              min="0"
              max="100"
              value={sliderValue}
              onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
            />
            <div className="labels" style={{ marginBottom: -15 }}>
              <span className="low">$5</span>
              <span className="high">$410</span>
            </div>
          </div>
        </div>

      <div className="product-grid">
        {currentProducts.length > 0 ? (
          currentProducts.map((product, index) => (
            <div key={index} className="product-card">
              <HashLink
                to={`/product-drinkwear/${product.Style}`}
                style={{ textDecoration: "none", color: "black" }}
              >
                <div className="image-container">
                  {product.isOnSale && (
                    <div className="sale-badge">
                      {product.DiscountPercentage}% OFF
                    </div>
                  )}
                  <img
                    src={product.DefaultImageSrc}
                    alt={product.Handle}
                    className="product-image default-image"
                  />
                  <img
                    src={product.HoverImageSrc}
                    alt={`${product.Handle} Hover`}
                    className="product-image hover-image"
                  />
                </div>

                <div className="product-details">
                  <h3 className="product-handle">{product.Handle}</h3>
                  <div className="product-price">
                    Price: From{" "}
                    {product.SalePrice > 0 && product.SalePrice < product.Price ? (
                      <>
                        <span
                          className="product-price"
                          style={{ textDecoration: "line-through", color: "grey" }}
                        >
                          ${(product.Price).toFixed(2)}
                        </span>{" "}
                        <span className="text-red-600 font-bold">
                          ${(product.SalePrice).toFixed(2)}
                        </span>
                      </>
                    ) : (
                      <> ${(product.Price).toFixed(2)}</>
                    )}
                  </div>
                </div>

              
              </HashLink>
                {/* <div className="product-details2">MOQ: {product.min} pcs</div> */}
            </div>
          ))
        ) : (
            <img
            style={{ width: 200, marginTop: 10 }}
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925292/my_uploads/wyd702qpywbgad4p7xqk.jpg"
            alt="No products found"
          />
        )}
      </div>
      </div>

      <div className="pagination">
        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          <img
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925250/my_uploads/o7m7damek0k2zanyyhcb.png"
            style={{ maxWidth: 35, marginRight: -50}}
            alt="First"
          />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
        </button>

        <span style={{marginLeft:-10}}>
          Page {currentPage} of {totalPages}
        </span>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <img src="/right-arrow.png" style={{ maxWidth: 35 , marginLeft:-15}} alt="Next" />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <img
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925251/my_uploads/ocislq4muj6wqc5aks2k.png"
            style={{ maxWidth: 35, marginLeft: -50 }}
            alt="Last"
          />
        </button>
      </div>
                  <div>
                    <a
                      href="#product-container"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <p style={{ fontSize: "30px", fontWeight: "bold" }}>
                        <GoMoveToTop />
                      </p>
                      <p style={{ marginTop: -25 }}>Top</p>
                    </a>
                  </div>
    </>
  );
};

export default DrinkwearMenu;
